import { z } from 'zod';

/**
 * RDK has no "save every plan" flag. Its gate is `elapsed > threshold` with
 * elapsed always positive, so any negative threshold always matches.
 */
export const SAVE_ALL_PLANS_THRESHOLD_MS = -1;

/**
 * RDK does not expand `~`, so prefilled paths must be absolute. /tmp is a
 * convenient location writable regardless of which user runs viam-server
 */
export const DEFAULT_PLAN_FILE_PATH = '/tmp/viam-plans';
export const DEFAULT_LOG_FILE_PATH = '/tmp/viam-motion.log';

export const MotionServiceAttributesSchema = z
  .object({
    plan_file_path: z.string().optional(),
    log_file_path: z.string().optional(),
    log_planner_errors: z.boolean().optional(),
    log_slow_plan_threshold_ms: z.number().optional(),
    // RDK rejects a negative thread count at config load.
    num_threads: z.number().min(0).optional(),
    plan_directory_include_trace_id: z.boolean().optional(),
  })
  .passthrough();

export type MotionServiceAttributes = z.infer<
  typeof MotionServiceAttributesSchema
>;
